import { useReducer, type Reducer, ChangeEvent, useCallback } from 'react'

type State =
    | {
          type: 'edit'
          id: number
          value: string
      }
    | { type: 'delete'; id: number }
    | { type: 'idle' }

const INITIAL_STATE: State = { type: 'idle' }

type Action =
    | { type: 'edit_change'; payload: string }
    | {
          type: 'start_edit'
          payload: Omit<Extract<State, { type: 'edit' }>, 'type'>
      }
    | {
          type: 'start_delete'
          payload: Omit<Extract<State, { type: 'delete' }>, 'type'>
      }
    | { type: 'reset' }

const reducer: Reducer<State, Action> = (state, action) => {
    switch (action.type) {
        case 'edit_change': {
            if (state.type === 'edit') {
                return {
                    ...state,
                    value: action.payload,
                }
            }
            break
        }
        case 'start_edit': {
            if (state.type === 'idle') {
                return {
                    type: 'edit',
                    ...action.payload,
                }
            }
            break
        }
        case 'start_delete': {
            if (state.type === 'idle') {
                return {
                    type: 'delete',
                    ...action.payload,
                }
            }
            break
        }
    }

    return INITIAL_STATE
}

export const useEditCreativeItem = () => {
    const [state, dispatch] = useReducer(reducer, INITIAL_STATE)

    return {
        editState: state,
        onStartEdit: useCallback(
            (id: number, value: string) =>
                dispatch({ type: 'start_edit', payload: { id, value } }),
            []
        ),
        onStartDelete: useCallback(
            (id: number) =>
                dispatch({
                    type: 'start_delete',
                    payload: { id },
                }),
            []
        ),
        onReset: useCallback(() => dispatch({ type: 'reset' }), []),
        onChangeTitle: useCallback(
            (e: ChangeEvent<HTMLInputElement>) =>
                dispatch({ type: 'edit_change', payload: e.target.value }),
            []
        ),
    }
}

export type UseEditCreativeItem = ReturnType<typeof useEditCreativeItem>
